<template>
  <div class="main" id="zhongzzck">
    <div class="left">
      <zzleft @playData="playObj"></zzleft>
    </div>
    <div class="right">
      <myVideo ref="myVideo"></myVideo>
    </div>
  </div>
</template>
<script>
import zzleft from "./zhzz/zzleft.vue";
import myVideo from "./zhzz/video.vue";
export default {
  components: {
    zzleft,
    myVideo,
  },
  data() {
    return {};
  },
  methods: {
    playObj(v) {
      let obj = {
        channelId: v.channelId,
        deviceNo: v.deviceNo,
      };
      this.$refs.myVideo.play(obj);
    },
  },
};
</script>
<style scoped>
#zhongzzck {
  display: flex;
  overflow: hidden;
}
#zhongzzck .left {
  width: 200px;
}
#zhongzzck .right {
  width: calc(100% - 200px);
}
</style>



// WEBPACK FOOTER //
// src/components/zhongzz/zhongzzck.vue